import { Component } from '@angular/core';



@Component({
    selector: '[gpis-spa]',
    templateUrl: '../views/masterpage.html',
    
})

 export class AppComponent
 {

 }



// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/app.component.ts